(function () {
    angular
        .module('active-website-engagement.dir', ['ngclipboard'])
        .directive('activeWebsiteEngagement', ['$rootScope', '$compile', '$templateCache', 'helpers', 'canvasService', activeWebsiteEngagement])

    //Website Engagement Directive
    function activeWebsiteEngagement($rootScope, $compile, $templateCache, helpers, canvasService) {

        return {
            scope: {},
            controller: ['$scope', function ($scope) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.breakUrl = () => {
                    return $scope.data.specificUrl.replace(/(.{70})/g, "$1<br />");
                };

                $scope.parseDescription = function (desc, specificUrl) {
                    if (specificUrl) {
                        if (desc) {
                            var arrLen = desc.split("");
                            arrLen = arrLen.length;
                            if (arrLen > 15) {
                                return desc.slice(0, 15) + '...';
                            } else {
                                return desc;
                            }
                        } else if ($scope.data.source === 'contains-url') {
                            return $scope.translate('canvas.entry.websiteEngagement.containsUrl');
                        } else {
                            return $scope.translate('canvas.condition.websiteActivity.specificUrl');
                        }
                    } else {
                        if (desc) {
                            desc = desc.splitCharAndUpper();
                        } else {
                            return $scope.translate('commons.enterDetails');
                        }
                    }

                    return desc;
                };

                //Show or hide menu on Element click
                $scope.config = function (evt) {
                    //Show form menu
                    if ($scope.displayList === false) {
                        $scope.displayList = true;
                    } else {
                        $scope.displayList = false;
                        $scope.trackingTestClass = '';
                    }
                };

                $scope.showReport = () => {
                    const firstOccurrence = $scope.id.indexOf('_');
                    const secondOccurrence = $scope.id.indexOf('_', firstOccurrence + 1);
                    const elementId = $scope.id.slice(0, secondOccurrence);
                    canvasService.getNodeDetails($rootScope.currentAPId, elementId)
                        .then((res) => res.data)
                        .then((nodeDetails) => {
                            canvasService.getNodeMetricDetailsGroupByType($rootScope.currentAPId, nodeDetails.NodeId, nodeDetails.NodeActionType)
                                .then(function(res){
                                    const data = [
                                        nodeDetails,
                                        res.data,
                                    ];
                                    $rootScope.$emit('summary', true, $rootScope.currentAPId, $rootScope.currentJBTitle, undefined, -1, false, true, data);
                                })
                        });
                };

                $scope.contMenuConfigs = 0;
                $scope.stopMenuBroadcast = function() {
                    $scope.contMenuConfigs = 0;
                };

                $scope.$on('closeConfigMenus', function() {
                    if($scope.displayList || $scope.displaySubMenu) {
                        if ($scope.contMenuConfigs === 0) {
                            $scope.contMenuConfigs = 1;
                        }else {
                            $scope.cancel();
                            $scope.displaySubMenu = false;
                            $scope.contMenuConfigs = 0;
                        }
                    } else {
                        $scope.contMenuConfigs = 0;
                    }
                });
                //Close menu
                $scope.cancel = function() {
                    $scope.displayList = false;
                }

                $scope.displayTrackerModal = () => {
                    $rootScope.$emit('displayTrackerModal');
                };

                $scope.specificUrlOptions = [
                    {
                        value: 'any-tracked-page',
                        message: $scope.translate('canvas.entry.websiteEngagement.anyTracked')
                    },
                    {
                        value: 'is-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.specificUrl')
                    },
                    {
                        value: 'contains-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.containsUrl')
                    },
                    {
                        value: 'doesnotcontain-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.not.containsUrl')
                    },
                    {
                        value: 'startswith-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.starts.with.url')
                    },
                    {
                        value: 'endswith-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.ends.with.url')
                    },
                    {
                        value: 'wildcardmatch-url',
                        message: $scope.translate('canvas.entry.websiteEngagement.wildcard.url')
                    }
                ];

                $scope.blockTrigger = () => {
                    Intercom('trackEvent', 'AP - Block Trigger');
                    const status = $scope.blocked ? 1 : 0;
                    canvasService.blockJourney($rootScope.currentAPId, status)
                        .success(({ReportInformation}) => {
                            $scope.blocked = !$scope.blocked;
                            if($scope.blocked) {
                                $scope.blockDate = ReportInformation.History[8];
                            }
                        });
                };
            }],
            link: function (scope, elem, attr) {
                //Setting initial form on true to display radio buttons
                scope.displayForm = true;

                if($rootScope.aElement) {
                    // bullet proving multiple targets
                    if(document.getElementById($rootScope.aElement.id)) {
                        delete $rootScope.aElement;
                        return false;
                    }

                    // load template
                    var template = $templateCache.get('active_templates/entries/active-website-engagement'),
                        modalTemplate = $templateCache.get('active_templates/entries/modal-active-website-engagement');

                    scope.left = $rootScope.aElement.left;
                    scope.top = $rootScope.aElement.top;
                    scope.id = $rootScope.aElement.id;
                    scope.type = $rootScope.aElement.type;
                    scope.data = $rootScope.aElement.data;
                    scope.color = $rootScope.aElement.color;
                    scope.numbers = '0';

                    delete $rootScope.aElement;

                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    var modalContent = $compile(modalTemplate)(scope);
                    $('body').append(modalContent);

                    $rootScope.$on('reporter_' + $rootScope.currentAPId + scope.id, function(evt, data) {
                        if(data) {
                            scope.numbers = data;
                        }
                    });

                    $rootScope.$on('entryBlock', function(evt, block, date) {
                        scope.blocked = block;
                        scope.blockDate = date;
                    });
                }
            }
        };
    }

}());



// WEBPACK FOOTER //
// ./app/directives/canvas_active_directives/entries/active-website-engagement.js